<template>
  <b-modal
    id="modal-detail-sync"
    size="lg"
    title="Detail Data Sinkronisasi"
    hide-footer
  >
    <div class="list-detail-riwayat">
      <b-card
        no-body
        class="mb-1"
        v-for="d in detailRiwayatImport.detail"
        :key="d.id_det_riwayat_sync_penduduk"
      >
        <b-card-header
          header-tag="header"
          class="p-0"
          role="tab"
          style="min-height:inherit;border-radius:3px;cursor:pointer"
        >
          <div
            v-b-toggle="'detail-'+d.id_det_riwayat_sync_penduduk"
            class="p-3 d-flex"
            style="width:100%;border-radius:3px"
          >
            <b>{{ d.nama_lengkap }}</b>
            <div style="margin-left:auto">
              <span
                v-if="d.action == 1"
                class="badge badge-success"
              >
                <i class="fa fa-info-circle mr-2" />Data Baru
              </span>
              <span
                v-if="d.action == 2"
                class="badge badge-warning"
              >
                <i class="fa fa-info-circle mr-2" />Pembaruan
              </span>
            </div>
          </div>
        </b-card-header>
        <b-collapse
          :id="'detail-'+d.id_det_riwayat_sync_penduduk"
          role="tabpanel"
          accordion="list-detail-riwayat"
        >
          <b-card-body>
            <div class="table-responsive">
              <!-- table jika data baru -->
              <table
                v-if="d.action == 1"
                class="table table-md table-bordered"
              >
                <tbody>
                  <tr>
                    <td
                      class="font-weight-bold"
                    >
                      Nama Lengkap
                    </td>
                    <td
                      class="font-weight-bold"
                    >
                      NIK
                    </td>
                    <td
                      class="font-weight-bold"
                    >
                      Nomor KK
                    </td>
                    <td
                      class="font-weight-bold"
                    >
                      Jenis Kelamin
                    </td>
                    <td
                      class="font-weight-bold"
                    >
                      Tempat Lahir
                    </td>
                    <td
                      class="font-weight-bold"
                    >
                      Tanggal Lahir
                    </td>
                                        
                    <td
                      class="font-weight-bold"
                    >
                      Status Kawin
                    </td>
                                        
                    <td
                      class="font-weight-bold"
                    >
                      SHDK
                    </td>
                                        
                    <td
                      class="font-weight-bold"
                    >
                      Pendidikan
                    </td>
                                        
                    <td
                      class="font-weight-bold"
                    >
                      Pekerjaan
                    </td>
                                        
                    <td
                      class="font-weight-bold"
                    >
                      Agama
                    </td>
                                        
                    <td
                      class="font-weight-bold"
                    >
                      Nama Ayah
                    </td>
                                        
                    <td
                      class="font-weight-bold"
                    >
                      Nama Ibu
                    </td>
                                        
                    <td
                      class="font-weight-bold"
                    >
                      Alamat
                    </td>

                    <td
                      class="font-weight-bold"
                    >
                      Desa
                    </td>
                  </tr>
                  <tr>
                    <td>
                      {{ d.after.nama_lengkap }}
                    </td>
                    <td>
                      {{ d.after.nik }}
                    </td>
                    <td>
                      {{ d.after.no_kk }}
                    </td>
                    <td>
                      {{ (d.after.id_kelamin == 1) ? 'Laki-laki' : 'Perempuan' }}
                    </td>
                    <td>
                      {{ d.after.tempat_lahir }}
                    </td>
                    <td>
                      {{ d.after.tanggal_lahir }}
                    </td>
                    <td>
                      {{ d.after.status_kawin }}
                    </td>
                    <td>
                      {{ (d.after.shdk_det) ? d.after.shdk_det.nama_shdk : d.after.shdk }}
                    </td>
                    <td>
                      {{ d.after.pend_terakhir }}
                    </td>
                    <td>
                      {{ d.after.pekerjaan }}
                    </td>
                    <td>
                      {{ (d.after.agama) ? d.after.agama.nama_agama : d.after.id_agama }}
                    </td>
                    <td>
                      {{ d.after.nama_lengkap_ayah }}
                    </td>
                    <td>
                      {{ d.after.nama_lengkap_ibu }}
                    </td>
                    <td>
                      {{ d.after.alamat }}
                    </td>
                    <td>
                      {{ (d.after.desa) ? d.after.desa.nama_desa : d.after.id_desa }}
                    </td>
                  </tr>
                </tbody>
              </table>
              <table
                v-if="d.action == 2"
                class="table table-md table-bordered"
              >
                <tbody>
                  <tr>
                    <td />
                    <td
                      class="font-weight-bold"
                      :class="{'bg-warning-100': d.after.nama_lengkap != d.before.nama_lengkap}"
                    >
                      Nama Lengkap
                    </td>
                    <td
                      class="font-weight-bold"
                      :class="{'bg-warning-100': d.after.nik != d.before.nik}"
                    >
                      NIK
                    </td>
                    <td
                      class="font-weight-bold"
                      :class="{'bg-warning-100': d.after.no_kk != d.before.no_kk}"
                    >
                      Nomor KK
                    </td>
                    <td
                      class="font-weight-bold"
                      :class="{'bg-warning-100': d.after.id_kelamin != d.before.id_kelamin}"
                    >
                      Jenis Kelamin
                    </td>
                    <td
                      class="font-weight-bold"
                      :class="{'bg-warning-100': d.after.tempat_lahir != d.before.tempat_lahir}"
                    >
                      Tempat Lahir
                    </td>
                    <td
                      class="font-weight-bold"
                      :class="{'bg-warning-100': d.after.tanggal_lahir != d.before.tanggal_lahir}"
                    >
                      Tanggal Lahir
                    </td>
                                        
                    <td
                      class="font-weight-bold"
                      :class="{'bg-warning-100': d.after.status_kawin != d.before.status_kawin}"
                    >
                      Status Kawin
                    </td>
                                        
                    <td
                      class="font-weight-bold"
                      :class="{'bg-warning-100': d.after.shdk != d.before.shdk}"
                    >
                      SHDK
                    </td>
                                        
                    <td
                      class="font-weight-bold"
                      :class="{'bg-warning-100': d.after.pend_terakhir != d.before.pend_terakhir}"
                    >
                      Pendidikan
                    </td>
                                        
                    <td
                      class="font-weight-bold"
                      :class="{'bg-warning-100': d.after.pekerjaan != d.before.pekerjaan}"
                    >
                      Pekerjaan
                    </td>
                                        
                    <td
                      class="font-weight-bold"
                      :class="{'bg-warning-100': d.after.id_agama != d.before.id_agama}"
                    >
                      Agama
                    </td>
                                        
                    <td
                      class="font-weight-bold"
                      :class="{'bg-warning-100': d.after.nama_lengkap_ayah != d.before.nama_lengkap_ayah}"
                    >
                      Nama Ayah
                    </td>
                                        
                    <td
                      class="font-weight-bold"
                      :class="{'bg-warning-100': d.after.nama_lengkap_ibu != d.before.nama_lengkap_ibu}"
                    >
                      Nama Ibu
                    </td>
                                        
                    <td
                      class="font-weight-bold"
                      :class="{'bg-warning-100': d.after.alamat != d.before.alamat}"
                    >
                      Alamat
                    </td>

                    <td
                      class="font-weight-bold"
                      :class="{'bg-warning-100': d.after.id_desa != d.before.id_desa}"
                    >
                      Desa
                    </td>
                  </tr>
                                    
                  <tr>
                    <td class="font-weight-bold">
                      Sebelum
                    </td>
                    <td
                      :class="{'bg-warning-100': d.after.nama_lengkap != d.before.nama_lengkap}"
                    >
                      {{ d.before.nama_lengkap }}
                    </td>
                    <td
                      :class="{'bg-warning-100': d.after.nik != d.before.nik}"
                    >
                      {{ d.before.nik }}
                    </td>
                    <td
                      :class="{'bg-warning-100': d.after.no_kk != d.before.no_kk}"
                    >
                      {{ d.before.no_kk }}
                    </td>
                    <td
                      :class="{'bg-warning-100': d.after.id_kelamin != d.before.id_kelamin}"
                    >
                      {{ (d.before.id_kelamin == 1) ? 'Laki-laki' : 'Perempuan' }}
                    </td>
                    <td
                      :class="{'bg-warning-100': d.after.tempat_lahir != d.before.tempat_lahir}"
                    >
                      {{ d.before.tempat_lahir }}
                    </td>
                    <td
                      :class="{'bg-warning-100': d.after.tanggal_lahir != d.before.tanggal_lahir}"
                    >
                      {{ d.before.tanggal_lahir }}
                    </td>
                    <td
                      :class="{'bg-warning-100': d.after.status_kawin != d.before.status_kawin}"
                    >
                      {{ d.before.status_kawin }}
                    </td>
                    <td
                      :class="{'bg-warning-100': d.after.shdk != d.before.shdk}"
                    >
                      {{ (d.before.shdk_det) ? d.before.shdk_det.nama_shdk : d.before.shdk }}
                    </td>
                    <td
                      :class="{'bg-warning-100': d.after.pend_terakhir != d.before.pend_terakhir}"
                    >
                      {{ d.before.pend_terakhir }}
                    </td>
                    <td
                      :class="{'bg-warning-100': d.after.pekerjaan != d.before.pekerjaan}"
                    >
                      {{ d.before.pekerjaan }}
                    </td>
                    <td
                      :class="{'bg-warning-100': d.after.id_agama != d.before.id_agama}"
                    >
                      {{ (d.before.agama) ? d.before.agama.nama_agama : d.before.id_agama }}
                    </td>
                    <td
                      :class="{'bg-warning-100': d.after.nama_lengkap_ayah != d.before.nama_lengkap_ayah}"
                    >
                      {{ d.before.nama_lengkap_ayah }}
                    </td>
                    <td
                      :class="{'bg-warning-100': d.after.nama_lengkap_ibu != d.before.nama_lengkap_ibu}"
                    >
                      {{ d.before.nama_lengkap_ibu }}
                    </td>
                    <td
                      :class="{'bg-warning-100': d.after.alamat != d.before.alamat}"
                    >
                      {{ d.before.alamat }}
                    </td>
                    <td
                      :class="{'bg-warning-100': d.after.id_desa != d.before.id_desa}"
                    >
                      {{ (d.before.desa) ? d.before.desa.nama_desa : d.before.id_desa }}
                    </td>
                  </tr>
                  <tr>
                    <td class="font-weight-bold">
                      Sesudah
                    </td>
                    <td
                      :class="{'bg-warning-100': d.after.nama_lengkap != d.before.nama_lengkap}"
                    >
                      {{ d.after.nama_lengkap }}
                    </td>
                    <td
                      :class="{'bg-warning-100': d.after.nik != d.before.nik}"
                    >
                      {{ d.after.nik }}
                    </td>
                    <td
                      :class="{'bg-warning-100': d.after.no_kk != d.before.no_kk}"
                    >
                      {{ d.after.no_kk }}
                    </td>
                    <td
                      :class="{'bg-warning-100': d.after.id_kelamin != d.before.id_kelamin}"
                    >
                      {{ (d.after.id_kelamin == 1) ? 'Laki-laki' : 'Perempuan' }}
                    </td>
                    <td
                      :class="{'bg-warning-100': d.after.tempat_lahir != d.before.tempat_lahir}"
                    >
                      {{ d.after.tempat_lahir }}
                    </td>
                    <td
                      :class="{'bg-warning-100': d.after.tanggal_lahir != d.before.tanggal_lahir}"
                    >
                      {{ d.after.tanggal_lahir }}
                    </td>
                    <td
                      :class="{'bg-warning-100': d.after.status_kawin != d.before.status_kawin}"
                    >
                      {{ d.after.status_kawin }}
                    </td>
                    <td
                      :class="{'bg-warning-100': d.after.shdk != d.before.shdk}"
                    >
                      {{ (d.after.shdk_det) ? d.after.shdk_det.nama_shdk : d.after.shdk }}
                    </td>
                    <td
                      :class="{'bg-warning-100': d.after.pend_terakhir != d.before.pend_terakhir}"
                    >
                      {{ d.after.pend_terakhir }}
                    </td>
                    <td
                      :class="{'bg-warning-100': d.after.pekerjaan != d.before.pekerjaan}"
                    >
                      {{ d.after.pekerjaan }}
                    </td>
                    <td
                      :class="{'bg-warning-100': d.after.id_agama != d.before.id_agama}"
                    >
                      {{ (d.after.agama) ? d.after.agama.nama_agama : d.after.id_agama }}
                    </td>
                    <td
                      :class="{'bg-warning-100': d.after.nama_lengkap_ayah != d.before.nama_lengkap_ayah}"
                    >
                      {{ d.after.nama_lengkap_ayah }}
                    </td>
                    <td
                      :class="{'bg-warning-100': d.after.nama_lengkap_ibu != d.before.nama_lengkap_ibu}"
                    >
                      {{ d.after.nama_lengkap_ibu }}
                    </td>
                    <td
                      :class="{'bg-warning-100': d.after.alamat != d.before.alamat}"
                    >
                      {{ d.after.alamat }}
                    </td>
                    <td
                      :class="{'bg-warning-100': d.after.id_desa != d.before.id_desa}"
                    >
                      {{ (d.after.desa) ? d.after.desa.nama_desa : d.after.id_desa }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </b-card-body>
        </b-collapse>
      </b-card>
    </div>

    <div class="text-right">
      <button
        @click="$bvModal.hide('modal-detail-sync')"
        class="btn btn-secondary"
      >
        <i class="fa fa-times mr-2" />Tutup
      </button>
    </div>
  </b-modal>
</template>

<script>
export default {
    data() {
        return {

        }
    },
    props: {
        detailRiwayatImport: {
          type: Object,
          default: () => null
        }
    },
    methods: {
        getNamaShdk(id){
            this.$store.dispatch('show', id).then(res => {
                if(res.data.status){
                    return res.data.data.nama_shdk
                }
            })
        },
        getNamaAgama(id){

        },
        getNamaDesa(id){

        }
    }
}
</script>